import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRoutesState, ISelectedDriver, ITripsState } from "@types";

const initialState: ITripsState = {
  idRouteSelected: "",
  idVehicleSelected: "",
  driversSelected: [],
  nameVehicleSelected: "",
  route: null,
  isCustom: false,
  idTripSelected: "",
  fetchDetailData: null,
  routeCostData: null,
  backup: null,
};

export const TripsSlice = createSlice({
  name: "Trips",
  initialState,
  reducers: {
    setIdRouteSelected: (state, action: PayloadAction<string | null>) => {
      state.idRouteSelected = action.payload;
    },
    setIdTripSelected: (state, action: PayloadAction<string | null>) => {
      state.idTripSelected = action.payload;
    },
    setIdVehicleSelected: (state, action: PayloadAction<string | null>) => {
      state.idVehicleSelected = action.payload;
    },
    setDriversSelected: (state, action: PayloadAction<ISelectedDriver[]>) => {
      state.driversSelected = action.payload;
    },
    addDriverSelected: (state, action: PayloadAction<ISelectedDriver>) => {
      const exists = state.driversSelected.some(d => d.id === action.payload.id);
      if (!exists) {
        state.driversSelected.push(action.payload);
      }
    },
    removeDriverSelected: (state, action: PayloadAction<string>) => {
      state.driversSelected = state.driversSelected.filter(d => d.id !== action.payload);
    },
    setNameVehicleSelected: (state, action: PayloadAction<string | null>) => {
      state.nameVehicleSelected = action.payload;
    },
    setRouteTripSelected: (state, action: PayloadAction<IRoutesState>) => {
      state.route = action.payload;
    },
    setScheduleDateSelected: (state, action: PayloadAction<string | null>) => {
      state.scheduleDateSelected = action.payload;
    },
    setScheduleHoursSelected: (state, action: PayloadAction<string | null>) => {
      state.scheduleHoursSelected = action.payload;
    },
    setIsCustomTrip: (state, action: PayloadAction<boolean>) => {
      state.isCustom = action.payload;
    },
    clearTrip: () => initialState,
    setTripUpdateDetailData: (state, action: PayloadAction<any>) => {
      state.fetchDetailData = action.payload;
    },
    setTripUpdateRouteCostData: (state, action: PayloadAction<any>) => {
      state.routeCostData = action.payload;
    },
    setTripUpdateDetailDataUpdateOrigin: (state, action: PayloadAction<any>) => {
      state.fetchDetailData.data.result.originRoute = action.payload;
    },
    setTripUpdateDetailDataUpdateDestination: (state, action: PayloadAction<any>) => {
      state.fetchDetailData.data.result.destinyRoute = action.payload;
    },
    setTripUpdateClean: (state) => {
      state.fetchDetailData = undefined;
      state.routeCostData = undefined;
    },
    setBackupTrip: (state, action: PayloadAction<any>) => {
      state.backup = action.payload;
    },
  },
});

export const {
  setIdRouteSelected,
  setDriversSelected,
  addDriverSelected,
  removeDriverSelected,
  setIdVehicleSelected,
  clearTrip,
  setNameVehicleSelected,
  setRouteTripSelected,
  setIsCustomTrip,
  setScheduleDateSelected,
  setScheduleHoursSelected,
  setIdTripSelected,

  setTripUpdateDetailData,
  setTripUpdateRouteCostData,
  setTripUpdateDetailDataUpdateOrigin,
  setTripUpdateDetailDataUpdateDestination,
  setTripUpdateClean,
  setBackupTrip,
} = TripsSlice.actions;

export default TripsSlice.reducer;

